export function tagsparsed(state = [], action) {
  if (action.type === 'GET_TAG_PARSED') {
    return action.tags;
  }

  return state;
}
